import { Outlet } from 'react-router-dom';

export const PublicRoute = () => <Outlet />;
